<template>
  <div>
    <el-popover
      placement="bottom"
      :width="width || 400"
      :visible-arrow="false"
      :trigger="trigger || 'click'"
      v-model="showDrop"
      @after-leave="checked = value"
    >
      <div class="ms-dropdown">
        <div class="title">
          <el-button @click="handleAll" :class="{ checked: all }">
            全部
          </el-button>
        </div>
        <el-checkbox-group
          v-model="checked"
          class="checkbox-list"
          :style="bodyStyle"
        >
          <el-checkbox-button
            v-for="option in options"
            :label="option"
            class="item"
            :key="option.id || option.value"
            >{{ option.name }}</el-checkbox-button
          >
        </el-checkbox-group>
        <div class="buttons">
          <el-button @click="cancel">
            取消
          </el-button>
          <el-button @click="submit" type="primary">
            提交
          </el-button>
        </div>
      </div>
      <el-button
        slot="reference"
        :size="size || 'mini'"
        :class="['label', { active: showDrop }]"
      >
        <div class="label-container">
          <span v-if="all" :class="{ blue: showDrop }">{{ label }}</span>
          <span v-else class="blue">{{
            showDrop ? checkedLabel : valueLabel
          }}</span>
          <i :class="{ 'el-icon-arrow-down': true, down: showDrop }"></i>
        </div>
      </el-button>
    </el-popover>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'MultiSelecter',
  props: {
    options: Array, //选项
    width: String | Number, //弹框宽度
    value: Array, //绑定值
    trigger: String, //触发方式
    label: String, //按钮文字
    size: String, //
    bodyStyle: String //弹框样式
  },
  data() {
    return {
      checked: [],
      showDrop: false,
      all: true
    };
  },
  methods: {
    cancel() {
      this.showDrop = false;
    },
    submit() {
      this.$emit('update:value', this.checked);
      this.cancel();
    },
    handleAll() {
      this.checked = [];
    }
  },
  watch: {
    checked: function(newValue, oldValue) {
      this.all = (newValue.length === 0);
    },
    value: function(newValue, oldValue) {
      this.checked = newValue;
    }
  },
  computed: {
    checkedLabel() {
      return _.join(_.map(this.checked, 'name'), ' ');
    },
    valueLabel() {
      return _.join(_.map(this.value, 'name'), ' ');
    }
  }
};
</script>

<style scoped lang="scss">
.label {
  width: 150px;
  height: 32px;
  line-height: 32px;
  padding: 0;
  background: white;
  .label-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 10px;
    > span {
      text-align: left;
      max-width: 89px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: none;
      font-size: 14px;
      color: #75808B;
      &.blue {
        color: #3fb7ff !important;
      }
    }
    > i {
      margin-right: 9px;
      transition: 0.3s transform;
      &.down {
        transform: rotate(-180deg);
        color: #3fb7ff !important;
      }
    }
  }
}
.ms-dropdown {
  padding: 0 12px;
  .title {
    padding: 2px 12px 9px 0;
    border-bottom: 1px solid #e9edf0;
    button {
      border: none;
      font-size: 12px;
      font-weight:500;
      letter-spacing: -0.33px;
      color: #75808b !important;
      background: transparent !important;
      &:hover {
        background: #f4f6f8 !important;
        color: #3fb7ff !important;
      }
      &.checked {
        background: #f4f6f8 !important;
        color: #3fb7ff !important;
        &:hover {
          background: #3fb7ff !important;
          color: white !important;
        }
      }
    }
  }
  .checkbox-list {
    padding: 10px 0 2px 0;
    margin: 0 -4px;
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #e9edf0;
    .item {
      flex: none;
      border-radius: 4px;
      overflow: hidden;
      margin: 0 4px 8px 4px;
      :global(.el-checkbox-button__inner) {
        background: transparent;
        border-radius: 4px;
        padding: 6px 12px;
        border: none;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: -0.33px;
        color: #75808b;
        &:hover {
          background: #f4f6f8;
          color: #3fb7ff;
        }
      }
      &.is-checked {
        :global(.el-checkbox-button__inner) {
          background: #f4f6f8;
          border: none;
          font-size: 12px;
          font-weight: 500;
          letter-spacing: -0.33px;
          color: #3fb7ff;
          &:hover {
            background: #3fb7ff;
            color: white;
          }
        }
      }
    }
  }
  .buttons {
    display: flex;
    justify-content: flex-end;
    padding-top: 16px;
  }
}
</style>
